/**
 * Zod schema for the strict JSON envelope returned by the master Coach
 * Steve agent. Used by `router.ts` to validate the model's output before
 * we hand the routed intent off to a sub-agent.
 *
 * Keep this list of `sub_agent` values aligned with the names of the
 * registered agents in `agents/index.ts`. The router prompt also
 * inlines this list so the model picks from a fixed set of choices.
 */

import { z } from 'zod';

/** Names of registered Coach Steve sub-agents the router may pick. */
export const RouterSubAgent = z.enum([
  'practice',
  'gamePlan',
  'game',
  'formation',
  'depthChart',
  'roster',
  'stats',
  'attendance',
  'playbook',
  'help',
  'general_chat',
]);
export type RouterSubAgent = z.infer<typeof RouterSubAgent>;

/** Strict JSON envelope returned by the master agent. */
export const RouterIntentSchema = z
  .object({
    sub_agent: RouterSubAgent,
    action: z.string().min(1).default('handle'),
    params: z.record(z.unknown()).default({}),
    confidence: z.number().min(0).max(1),
    clarification: z.string().optional(),
    interrupt: z.boolean().optional(),
    follow_up: z.string().optional(),
    follow_up_agent: RouterSubAgent.optional(),
  })
  .strict();

export type ValidatedRouterIntent = z.infer<typeof RouterIntentSchema>;

/** Confidence threshold below which we fall back to the regex dispatcher. */
export const ROUTER_CONFIDENCE_THRESHOLD = 0.65;
